// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"823":"83c3f351","5719":"83c3f351","9342":"bc53d127"}[chunkId] + ".chunk.css";
};